import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';

import { environment } from 'src/environments/environment';
import { round1, round2 } from 'src/app/shared/round';

import { Document, DocItems } from 'src/app/shared/document';

@Component({
  selector: 'app-new-document-dlg-process-payment',
  templateUrl: './new-document-dlg-process-payment.component.html',
  styleUrls: ['./new-document-dlg-process-payment.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class NewDocumentDlgProcessPaymentComponent implements OnInit, OnChanges, OnDestroy {

  @Input() parentDocument: Document;

  @Input() newDocument: Document;

  public get hasParentDocument(): boolean { return (this.parentDocumentId && true); }

  parentDocumentId: number;

  totalSumInMc: number;         // Overall invoice sum
  paidBeforeSumInMc: number;    // Already paid sum
  paymentSumInMc: number;       // Current sum
  expectedSumInMc: number;      // Expected Sum (paidBeforeSumInMc + paymentSumInMc)

  totalSumInBc: number;

  paidBeforeSumInBc: number;

  paymentSumInBc: number;

  paidBeforeSumInPc: number;
  paymentSumInPc: number;
  expectedSumInPc: number;

  payTypes =
  [
    { "DOCTYPEID": 8, "DOCNAME": "Приходный кассовый ордер", "DOCNAME1": "Приходный кассовый ордер"},
    { "DOCTYPEID": 9, "DOCNAME": "Банковская выписка", "DOCNAME1": "Платежное поручение покупателя"},
    { "DOCTYPEID": 11,"DOCNAME": "Взаимозачет", "DOCNAME1": "Залог"},
  ];

  selectedPayType: any = { };

  @Output() blocking: EventEmitter<boolean> = new EventEmitter();

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      let change = changes[propName];

      console.log('*** NewDocumentDlgProcessPaymentComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));

      switch (propName) {

        case 'newDocument':
          if (this.newDocument) {
            this.selectedPayType = this.payTypes.find(e => e.DOCTYPEID == this.newDocument.DOCTYPE);
          }
          break;

        case 'parentDocument':

        /*
          totalSumInMc: number;         // Overall invoice sum
          paidBeforeSumInMc: number;    // Already paid sum
          paymentSumInMc: number;       // Current sum
          expectedSumInMc: number;      // Expected Sum (paidBeforeSumInMc + paymentSumInMc)
         */

          this.totalSumInMc = this.parentDocument.DOCSUM;
          this.paidBeforeSumInMc = this.parentDocument.DOCPAIDSUM;
          // Bank-payment review MVP: this used to hardcode 0 unconditionally, which
          // was invisible before because DOCITEMPRICE was always 0 anyway on a fresh
          // "Провести оплату" click. The bank-payment review dialog now seeds a real
          // DOCITEMPRICE onto newDocument before this component ever mounts (both
          // @Input()s arrive together on first change detection, so newDocument is
          // already populated by the time this branch runs) -- read it back instead
          // of discarding it, or the visible "Сумма платежа" field would show 0 while
          // the document actually being saved carries the real bank amount.
          this.paymentSumInMc = this.newDocument?.items?.find(e => e.PRODID == 0)?.DOCITEMPRICE ?? 0;

          this.expectedSumInMc = this.paidBeforeSumInMc + this.paymentSumInMc;

          this.totalSumInBc = this.parentDocument.DOCVSUM;
          this.paidBeforeSumInBc = this.parentDocument.DOCPAIDSUMVAL;
          this.paymentSumInBc = 0;

          //this.expectedSumInBc = this.paidBeforeSumInBc + this.paymentSumInBc;

          this.paidBeforeSumInPc = (this.parentDocument.DOCPAIDSUM / this.parentDocument.DOCSUM) * 100;
          this.paymentSumInPc = 0;

          this.expectedSumInPc = Math.trunc(((this.paidBeforeSumInMc + this.paymentSumInMc) / this.totalSumInMc) * 1000) / 10;

          break;
      }
    }
  }

  ngOnDestroy(): void {
    console.log('*** NewDocumentDlgProcessPaymentComponent in ngOnDestroy')
  }

  ngOnInit(): void {
    console.log('*** NewDocumentDlgProcessPaymentComponent in ngOnInit');
  }

  onInputEx(event) {
    console.log('*** NewDocumentDlgProcessPaymentComponent onInputEx ' + JSON.stringify(event));

    this.expectedSumInPc = round1(((this.paidBeforeSumInMc + this.paymentSumInMc) / this.totalSumInMc) * 100);
  }

  onChangeEx(event) {
    console.log('*** NewDocumentDlgProcessPaymentComponent onChangeEx ' + JSON.stringify(event));

    this.expectedSumInPc = round1(((this.paidBeforeSumInMc + this.paymentSumInMc) / this.totalSumInMc) * 100);
  }

  onSlideEndEx(event) {
    console.log('*** NewDocumentDlgProcessPaymentComponent onSlideEndEx ' + JSON.stringify(event));

    this.expectedSumInPc = round1(((this.paidBeforeSumInMc + this.paymentSumInMc) / this.totalSumInMc) * 100);
  }

  onInputMc(event) {
    console.log('*** NewDocumentDlgProcessPaymentComponent onInputMc ' + JSON.stringify(event));

    this.expectedSumInMc = this.paidBeforeSumInMc + this.paymentSumInMc;
    this.expectedSumInPc = round1(((this.paidBeforeSumInMc + this.paymentSumInMc) / this.totalSumInMc) * 100);
    this.doUpdateDocItemRow();
  }

  onChangeMc(event) {
    console.log('*** NewDocumentDlgProcessPaymentComponent onChangeMc ' + JSON.stringify(event));

    this.expectedSumInMc = this.paidBeforeSumInMc + this.paymentSumInMc;
    this.expectedSumInPc = round1(((this.paidBeforeSumInMc + this.paymentSumInMc) / this.totalSumInMc) * 100);
    this.doUpdateDocItemRow();
  }

  onSlideEndMc(event) {
    console.log('*** NewDocumentDlgProcessPaymentComponent onSlideEndMc ' + JSON.stringify(event));

    this.expectedSumInMc = this.paidBeforeSumInMc + this.paymentSumInMc;
    this.expectedSumInPc = round1(((this.paidBeforeSumInMc + this.paymentSumInMc) / this.totalSumInMc) * 100);
    this.doUpdateDocItemRow();
  }

  onInputBc(event) {
    console.log('*** NewDocumentDlgProcessPaymentComponent onInputBc ' + JSON.stringify(event));

  }

  onChangeBc(event) {
    console.log('*** NewDocumentDlgProcessPaymentComponent onChangeBc ' + JSON.stringify(event));

  }

  onSlideEndBc(event) {
    console.log('*** NewDocumentDlgProcessPaymentComponent onSlideEndBc ' + JSON.stringify(event));

  }

  onInputPc(event) {
    console.log('*** NewDocumentDlgProcessPaymentComponent onInputPc ' + JSON.stringify(event));

    this.paymentSumInMc = round2(((this.totalSumInMc * this.expectedSumInPc / 100) - this.paidBeforeSumInMc));
    this.expectedSumInMc = this.paidBeforeSumInMc + this.paymentSumInMc;
    this.doUpdateDocItemRow();
  }

  onChangePc(event) {
    console.log('*** NewDocumentDlgProcessPaymentComponent onChangePc ' + JSON.stringify(event));

    this.paymentSumInMc = round2(((this.totalSumInMc * this.expectedSumInPc / 100) - this.paidBeforeSumInMc));
    this.expectedSumInMc = this.paidBeforeSumInMc + this.paymentSumInMc;
    this.doUpdateDocItemRow();
  }

  onSlideEndPc(event) {
    console.log('*** NewDocumentDlgProcessPaymentComponent onSlideEndPc ' + JSON.stringify(event));

    this.paymentSumInMc = round2(((this.totalSumInMc * this.expectedSumInPc / 100) - this.paidBeforeSumInMc));
    this.expectedSumInMc = this.paidBeforeSumInMc + this.paymentSumInMc;

    this.doUpdateDocItemRow();
  }

  doUpdateDocItemRow() {
    console.log('*** NewDocumentDlgProcessPaymentComponent doUpdateDocItemRow ');

    let di: DocItems = this.newDocument.items.find(e => e.PRODID == 0);

    di.DOCITEMPRICE = this.paymentSumInMc;
    di.DOCITEMVPRICE = this.paymentSumInMc / di.DOCITEMCRATE;
    di.DOCITEMQTY = 1;
    di.DOCITEMSUM = di.DOCITEMPRICE * di.DOCITEMQTY;
  }

  onDocTypeChanges(event) {
    console.log('*** NewDocumentDlgProcessPaymentComponent onDocTypeChanges ' + JSON.stringify(event));

    this.selectedPayType = this.payTypes.find(e => e.DOCTYPEID == event.value);
  }

}
